import React, { useEffect } from 'react';
import Button from '../../../components/button/Button';
import title from '../../../assets/webp-images/challenge-ob-impact-title.png';
import creative1 from '../../../assets/webp-images/challenge-ob-impact-creative-1.png';
import creative2 from '../../../assets/webp-images/challenge-ob-impact-creative-2.png';
import creative3 from '../../../assets/webp-images/challenge-ob-impact-creative-3.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-cards';
import { Mixpanel } from '../../../analytics/Mixpanel';

type Props = {
	onContinue: () => void;
};

const ChallengeObLessons: React.FC<Props> = ({ onContinue }) => {
	const slidesArray = [creative1, creative2, creative3];
	const onContinueTap = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: 'Real People. Real Impact',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: 'challenge',
		});
		onContinue();
	};

	useEffect(() => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading: 'Real People. Real Impact',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: 'challenge',
		});
	}, []);

	return (
		<div>
			<img src={title} style={{ width: '100%', marginTop: '16px' }} alt='' />

			<div style={{ marginTop: '48px', borderRadius: '12px' }}>
				<Swiper
					modules={[Autoplay]}
					grabCursor={true}
					autoplay={{ delay: 2000, disableOnInteraction: false }}
					cardsEffect={{
						slideShadows: false,
					}}
					style={{
						width: '100%',
						borderRadius: '12px',
					}}
					className='custom-cards-swiper'>
					{slidesArray.map((img, index) => (
						<SwiperSlide key={index}>
							<img
								src={img}
								style={{ width: '100%', borderRadius: '12px' }}
								alt=''
							/>
						</SwiperSlide>
					))}
				</Swiper>
				<style>
					{`
						.custom-cards-swiper .swiper-slide {
							transition: transform 0.3s ease, opacity 0.3s ease;
						}
						.custom-cards-swiper .swiper-slide:not(.swiper-slide-active) {
							transform: scale(0.85);
							opacity: 0.5;
						}
					`}
				</style>
			</div>

			<Button
				isSticky={true}
				style={{
					alignSelf: 'center',
					marginBottom: '24px',
					width: 'calc(100% - 56px)',
					background:
						'var(--Primary_Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
				}}
				onClick={onContinueTap}
				label={'Continue'}></Button>
		</div>
	);
};

export default ChallengeObLessons;
